import { type FC } from "react";
import type { MaybeType } from "@/shared/types";
import styles from "./styles.module.scss";

type Props = {
  title: MaybeType<string>;
};

export const TitleRecord: FC<Props> = ({ title }) => {
  return <div className={styles.title}>{title}</div>;
};
